"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceHeader = class UcInvoiceHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    invoiceNumber;
    onInvoice_number(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoiceNumber");
    }
    formContext;
    onForm_context(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formContext");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    newTransaction: this.$fn.pgettext("Invoice", "New Invoice"),
                    invoiceKind: {
                        incoming: this.$fn.pgettext("InvoiceKind", "Incoming Invoice"),
                        outgoing: this.$fn.pgettext("InvoiceKind", "Outgoing Invoice"),
                    },
                    createCorrectorTooltip: this.$fn.pgettext("Invoice", "Create corrector invoice"),
                    createStornoTooltip: this.$fn.pgettext("Invoice", "Create storno invoice"),
                    createPassThroughTooltip: this.$fn.pgettext("Invoice|Tooltip", "Rebilling the line items to a designated client."),
                    createAdvanceInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create advance invoice from a Pro Forma invoice."),
                    createFinalInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create final invoice from a Pro Forma or advance invoice."),
                },
                ux: null,
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.messages.invoiceKind[this.invoice.invoice_kind];
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.invoiceNumber || (this.invoice.isNew ? this.messages.newTransaction : this.invoice.invoice_number);
        }
        return null;
    }
    get createCorrectorTooltip() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.modifiable.message') || this.messages.createCorrectorTooltip;
        }
        return null;
    }
    get createStornoTooltip() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.reversible.message') || this.messages.createStornoTooltip;
        }
        return null;
    }
    get invoiceIsReversible() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.reversible.result');
        }
        return null;
    }
    get invoiceIsModifiable() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.modifiable.result');
        }
        return null;
    }
    get invoiceIsRegistrable() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.registrable.result');
        }
        return null;
    }
    get invoicePassThroughIsEnabled() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.pass_through_enabled') === true ||
                _.get(this.invoice, 'meta.pass_through_enabled.result');
        }
        return null;
    }
    get canCreateAdvanceInvoice() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.can_create_advance_invoice') === true;
        }
        return null;
    }
    get canCreateFinalInvoice() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.can_create_final_invoice') === true;
        }
        return null;
    }
    async act_1048678296148443_emit_7134_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1048678296148443_reload(event, scope) {
        return await this.actions.evh_1048678296148443_reload.executeFromDOM(this, event, scope);
    }
    async act_6639903447389385_emit_7136_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_6639903447389385_success(event, scope) {
        return await this.actions.evh_6639903447389385_success.executeFromDOM(this, event, scope);
    }
    async act_3803044933457651_emit_7138_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3803044933457651_success(event, scope) {
        return await this.actions.evh_3803044933457651_success.executeFromDOM(this, event, scope);
    }
    async act_4764767232201234_emit_7140_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4764767232201234_success(event, scope) {
        return await this.actions.evh_4764767232201234_success.executeFromDOM(this, event, scope);
    }
    async act_7992484462910578_emit_7142_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7992484462910578_success(event, scope) {
        return await this.actions.evh_7992484462910578_success.executeFromDOM(this, event, scope);
    }
    async act_7716964648426498_emit_7146_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7716964648426498_close_7145_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_7716964648426498_showModal_7144_getActionArgs($event) {
        return {
            name: "InvoiceEditor",
            props: {
                invoice: _.cloneDeep(this.invoice),
            },
        };
    }
    async evh_7716964648426498_clickPreventStop(event, scope) {
        return await this.actions.evh_7716964648426498_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2940653511262489_emit_7148_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_2940653511262489_clickPreventStop(event, scope) {
        return await this.actions.evh_2940653511262489_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_689536327456849_emit_7150_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_689536327456849_clickPreventStop(event, scope) {
        return await this.actions.evh_689536327456849_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8254501898831426_showModal_7152_getActionArgs($event) {
        return {
            name: "InvoiceLogMessageViewer",
            props: {
                invoiceId: this.invoice.id,
            },
        };
    }
    async evh_8254501898831426_clickPreventStop(event, scope) {
        return await this.actions.evh_8254501898831426_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_951936257455896_emit_7156_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_951936257455896_close_7155_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_951936257455896_showModal_7154_getActionArgs($event) {
        return {
            name: "RegisterEntry",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_951936257455896_click(event, scope) {
        return await this.actions.evh_951936257455896_click.executeFromDOM(this, event, scope);
    }
    async act_7010716094810887_emit_7160_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_7010716094810887_request_7158_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'copy' },
        };
    }
    async evh_7010716094810887_click(event, scope) {
        return await this.actions.evh_7010716094810887_click.executeFromDOM(this, event, scope);
    }
    async act_4971252216919813_emit_7164_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4971252216919813_close_7163_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_4971252216919813_showModal_7162_getActionArgs($event) {
        return {
            name: "CreatePassThroughInvoice",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_4971252216919813_click(event, scope) {
        return await this.actions.evh_4971252216919813_click.executeFromDOM(this, event, scope);
    }
    async act_3581444176199717_emit_7168_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_3581444176199717_request_7166_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'advance' },
        };
    }
    async evh_3581444176199717_click(event, scope) {
        return await this.actions.evh_3581444176199717_click.executeFromDOM(this, event, scope);
    }
    async act_6391442819935878_emit_7172_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_6391442819935878_request_7170_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'final' },
        };
    }
    async evh_6391442819935878_click(event, scope) {
        return await this.actions.evh_6391442819935878_click.executeFromDOM(this, event, scope);
    }
    async act_2988515090283815_emit_7176_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_2988515090283815_request_7174_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'storno' },
        };
    }
    async evh_2988515090283815_click(event, scope) {
        return await this.actions.evh_2988515090283815_click.executeFromDOM(this, event, scope);
    }
    async act_3478991899028773_emit_7180_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_3478991899028773_request_7178_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: {
                invoice_id: this.invoice.id,
                invoice_type: 'correction',
                invoice_lines: _.map(this.formContext.selectedInvoiceLines, p => p.id).join(',')
            },
        };
    }
    async evh_3478991899028773_click(event, scope) {
        return await this.actions.evh_3478991899028773_click.executeFromDOM(this, event, scope);
    }
    async act_8376575288437415_emit_7182_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8376575288437415_success(event, scope) {
        return await this.actions.evh_8376575288437415_success.executeFromDOM(this, event, scope);
    }
    async act_3958027742391354_emit_7184_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_3958027742391354_success(event, scope) {
        return await this.actions.evh_3958027742391354_success.executeFromDOM(this, event, scope);
    }
    async act_8122162285230843_showModal_7186_getActionArgs($event) {
        return {
            name: "entityEvents",
            props: {
                entityId: this.invoice.id,
            },
        };
    }
    async evh_8122162285230843_clickPreventStop(event, scope) {
        return await this.actions.evh_8122162285230843_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1048678296148443_emit_7134 = new core_1.actions.EmitAction({
            actionArgs: this.act_1048678296148443_emit_7134_getActionArgs,
            events: [],
        });
        const evh_1048678296148443_reload_7133 = new core_1.actions.EventHandlerImpl({
            action: act_1048678296148443_emit_7134,
            event: "reload",
            displayName: "emit",
        });
        const evh_1048678296148443_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1048678296148443_reload_7133],
        });
        const act_6639903447389385_emit_7136 = new core_1.actions.EmitAction({
            actionArgs: this.act_6639903447389385_emit_7136_getActionArgs,
            events: [],
        });
        const evh_6639903447389385_success_7135 = new core_1.actions.EventHandlerImpl({
            action: act_6639903447389385_emit_7136,
            event: "success",
            displayName: "emit",
        });
        const evh_6639903447389385_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6639903447389385_success_7135],
        });
        const act_3803044933457651_emit_7138 = new core_1.actions.EmitAction({
            actionArgs: this.act_3803044933457651_emit_7138_getActionArgs,
            events: [],
        });
        const evh_3803044933457651_success_7137 = new core_1.actions.EventHandlerImpl({
            action: act_3803044933457651_emit_7138,
            event: "success",
            displayName: "emit",
        });
        const evh_3803044933457651_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3803044933457651_success_7137],
        });
        const act_4764767232201234_emit_7140 = new core_1.actions.EmitAction({
            actionArgs: this.act_4764767232201234_emit_7140_getActionArgs,
            events: [],
        });
        const evh_4764767232201234_success_7139 = new core_1.actions.EventHandlerImpl({
            action: act_4764767232201234_emit_7140,
            event: "success",
            displayName: "emit",
        });
        const evh_4764767232201234_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4764767232201234_success_7139],
        });
        const act_7992484462910578_emit_7142 = new core_1.actions.EmitAction({
            actionArgs: this.act_7992484462910578_emit_7142_getActionArgs,
            events: [],
        });
        const evh_7992484462910578_success_7141 = new core_1.actions.EventHandlerImpl({
            action: act_7992484462910578_emit_7142,
            event: "success",
            displayName: "emit",
        });
        const evh_7992484462910578_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7992484462910578_success_7141],
        });
        const act_7716964648426498_emit_7146 = new core_1.actions.EmitAction({
            actionArgs: this.act_7716964648426498_emit_7146_getActionArgs,
            events: [],
        });
        const evh_7716964648426498_close_7145 = new core_1.actions.EventHandlerImpl({
            action: act_7716964648426498_emit_7146,
            event: "close",
            when: this.evh_7716964648426498_close_7145_getWhen,
            displayName: "emit",
        });
        const act_7716964648426498_showModal_7144 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7716964648426498_showModal_7144_getActionArgs,
            events: [evh_7716964648426498_close_7145],
        });
        const evh_7716964648426498_clickPreventStop_7143 = new core_1.actions.EventHandlerImpl({
            action: act_7716964648426498_showModal_7144,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_7716964648426498_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7716964648426498_clickPreventStop_7143],
        });
        const act_2940653511262489_emit_7148 = new core_1.actions.EmitAction({
            actionArgs: this.act_2940653511262489_emit_7148_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_2940653511262489_clickPreventStop_7147 = new core_1.actions.EventHandlerImpl({
            action: act_2940653511262489_emit_7148,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_2940653511262489_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2940653511262489_clickPreventStop_7147],
        });
        const act_689536327456849_emit_7150 = new core_1.actions.EmitAction({
            actionArgs: this.act_689536327456849_emit_7150_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_689536327456849_clickPreventStop_7149 = new core_1.actions.EventHandlerImpl({
            action: act_689536327456849_emit_7150,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_689536327456849_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_689536327456849_clickPreventStop_7149],
        });
        const act_8254501898831426_showModal_7152 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8254501898831426_showModal_7152_getActionArgs,
            events: [],
        });
        const evh_8254501898831426_clickPreventStop_7151 = new core_1.actions.EventHandlerImpl({
            action: act_8254501898831426_showModal_7152,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8254501898831426_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8254501898831426_clickPreventStop_7151],
        });
        const act_951936257455896_emit_7156 = new core_1.actions.EmitAction({
            actionArgs: this.act_951936257455896_emit_7156_getActionArgs,
            events: [],
        });
        const evh_951936257455896_close_7155 = new core_1.actions.EventHandlerImpl({
            action: act_951936257455896_emit_7156,
            event: "close",
            when: this.evh_951936257455896_close_7155_getWhen,
            displayName: "emit",
        });
        const act_951936257455896_showModal_7154 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_951936257455896_showModal_7154_getActionArgs,
            displayName: "registerInvoice",
            events: [evh_951936257455896_close_7155],
        });
        const evh_951936257455896_click_7153 = new core_1.actions.EventHandlerImpl({
            action: act_951936257455896_showModal_7154,
            event: "click",
            displayName: "registerInvoice",
        });
        const evh_951936257455896_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_951936257455896_click_7153],
        });
        const act_7010716094810887_emit_7160 = new core_1.actions.EmitAction({
            actionArgs: this.act_7010716094810887_emit_7160_getActionArgs,
            events: [],
        });
        const evh_7010716094810887_success_7159 = new core_1.actions.EventHandlerImpl({
            action: act_7010716094810887_emit_7160,
            event: "success",
            displayName: "emit",
        });
        const act_7010716094810887_request_7158 = new core_1.actions.RequestAction({
            actionArgs: this.act_7010716094810887_request_7158_getActionArgs,
            displayName: "createInvoicecopy",
            events: [evh_7010716094810887_success_7159],
        });
        const evh_7010716094810887_click_7157 = new core_1.actions.EventHandlerImpl({
            action: act_7010716094810887_request_7158,
            event: "click",
            displayName: "createInvoicecopy",
        });
        const evh_7010716094810887_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7010716094810887_click_7157],
        });
        const act_4971252216919813_emit_7164 = new core_1.actions.EmitAction({
            actionArgs: this.act_4971252216919813_emit_7164_getActionArgs,
            events: [],
        });
        const evh_4971252216919813_close_7163 = new core_1.actions.EventHandlerImpl({
            action: act_4971252216919813_emit_7164,
            event: "close",
            when: this.evh_4971252216919813_close_7163_getWhen,
            displayName: "emit",
        });
        const act_4971252216919813_showModal_7162 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4971252216919813_showModal_7162_getActionArgs,
            displayName: "createPassThroughInvoice",
            events: [evh_4971252216919813_close_7163],
        });
        const evh_4971252216919813_click_7161 = new core_1.actions.EventHandlerImpl({
            action: act_4971252216919813_showModal_7162,
            event: "click",
            displayName: "createPassThroughInvoice",
        });
        const evh_4971252216919813_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4971252216919813_click_7161],
        });
        const act_3581444176199717_emit_7168 = new core_1.actions.EmitAction({
            actionArgs: this.act_3581444176199717_emit_7168_getActionArgs,
            events: [],
        });
        const evh_3581444176199717_success_7167 = new core_1.actions.EventHandlerImpl({
            action: act_3581444176199717_emit_7168,
            event: "success",
            displayName: "emit",
        });
        const act_3581444176199717_request_7166 = new core_1.actions.RequestAction({
            actionArgs: this.act_3581444176199717_request_7166_getActionArgs,
            displayName: "createAdvanceInvoice",
            events: [evh_3581444176199717_success_7167],
        });
        const evh_3581444176199717_click_7165 = new core_1.actions.EventHandlerImpl({
            action: act_3581444176199717_request_7166,
            event: "click",
            displayName: "createAdvanceInvoice",
        });
        const evh_3581444176199717_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3581444176199717_click_7165],
        });
        const act_6391442819935878_emit_7172 = new core_1.actions.EmitAction({
            actionArgs: this.act_6391442819935878_emit_7172_getActionArgs,
            events: [],
        });
        const evh_6391442819935878_success_7171 = new core_1.actions.EventHandlerImpl({
            action: act_6391442819935878_emit_7172,
            event: "success",
            displayName: "emit",
        });
        const act_6391442819935878_request_7170 = new core_1.actions.RequestAction({
            actionArgs: this.act_6391442819935878_request_7170_getActionArgs,
            displayName: "createFinalInvoice",
            events: [evh_6391442819935878_success_7171],
        });
        const evh_6391442819935878_click_7169 = new core_1.actions.EventHandlerImpl({
            action: act_6391442819935878_request_7170,
            event: "click",
            displayName: "createFinalInvoice",
        });
        const evh_6391442819935878_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6391442819935878_click_7169],
        });
        const act_2988515090283815_emit_7176 = new core_1.actions.EmitAction({
            actionArgs: this.act_2988515090283815_emit_7176_getActionArgs,
            events: [],
        });
        const evh_2988515090283815_success_7175 = new core_1.actions.EventHandlerImpl({
            action: act_2988515090283815_emit_7176,
            event: "success",
            displayName: "emit",
        });
        const act_2988515090283815_request_7174 = new core_1.actions.RequestAction({
            actionArgs: this.act_2988515090283815_request_7174_getActionArgs,
            displayName: "createStornoInvoice",
            events: [evh_2988515090283815_success_7175],
        });
        const evh_2988515090283815_click_7173 = new core_1.actions.EventHandlerImpl({
            action: act_2988515090283815_request_7174,
            event: "click",
            displayName: "createStornoInvoice",
        });
        const evh_2988515090283815_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2988515090283815_click_7173],
        });
        const act_3478991899028773_emit_7180 = new core_1.actions.EmitAction({
            actionArgs: this.act_3478991899028773_emit_7180_getActionArgs,
            events: [],
        });
        const evh_3478991899028773_success_7179 = new core_1.actions.EventHandlerImpl({
            action: act_3478991899028773_emit_7180,
            event: "success",
            displayName: "emit",
        });
        const act_3478991899028773_request_7178 = new core_1.actions.RequestAction({
            actionArgs: this.act_3478991899028773_request_7178_getActionArgs,
            displayName: "createCorrectorIvoice",
            events: [evh_3478991899028773_success_7179],
        });
        const evh_3478991899028773_click_7177 = new core_1.actions.EventHandlerImpl({
            action: act_3478991899028773_request_7178,
            event: "click",
            displayName: "createCorrectorIvoice",
        });
        const evh_3478991899028773_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3478991899028773_click_7177],
        });
        const act_8376575288437415_emit_7182 = new core_1.actions.EmitAction({
            actionArgs: this.act_8376575288437415_emit_7182_getActionArgs,
            events: [],
        });
        const evh_8376575288437415_success_7181 = new core_1.actions.EventHandlerImpl({
            action: act_8376575288437415_emit_7182,
            event: "success",
            displayName: "emit",
        });
        const evh_8376575288437415_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8376575288437415_success_7181],
        });
        const act_3958027742391354_emit_7184 = new core_1.actions.EmitAction({
            actionArgs: this.act_3958027742391354_emit_7184_getActionArgs,
            events: [],
        });
        const evh_3958027742391354_success_7183 = new core_1.actions.EventHandlerImpl({
            action: act_3958027742391354_emit_7184,
            event: "success",
            displayName: "emit",
        });
        const evh_3958027742391354_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3958027742391354_success_7183],
        });
        const act_8122162285230843_showModal_7186 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8122162285230843_showModal_7186_getActionArgs,
            events: [],
        });
        const evh_8122162285230843_clickPreventStop_7185 = new core_1.actions.EventHandlerImpl({
            action: act_8122162285230843_showModal_7186,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8122162285230843_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8122162285230843_clickPreventStop_7185],
        });
        return {
            act_1048678296148443_emit_7134,
            evh_1048678296148443_reload_7133,
            evh_1048678296148443_reload,
            act_6639903447389385_emit_7136,
            evh_6639903447389385_success_7135,
            evh_6639903447389385_success,
            act_3803044933457651_emit_7138,
            evh_3803044933457651_success_7137,
            evh_3803044933457651_success,
            act_4764767232201234_emit_7140,
            evh_4764767232201234_success_7139,
            evh_4764767232201234_success,
            act_7992484462910578_emit_7142,
            evh_7992484462910578_success_7141,
            evh_7992484462910578_success,
            act_7716964648426498_emit_7146,
            evh_7716964648426498_close_7145,
            act_7716964648426498_showModal_7144,
            evh_7716964648426498_clickPreventStop_7143,
            evh_7716964648426498_clickPreventStop,
            act_2940653511262489_emit_7148,
            evh_2940653511262489_clickPreventStop_7147,
            evh_2940653511262489_clickPreventStop,
            act_689536327456849_emit_7150,
            evh_689536327456849_clickPreventStop_7149,
            evh_689536327456849_clickPreventStop,
            act_8254501898831426_showModal_7152,
            evh_8254501898831426_clickPreventStop_7151,
            evh_8254501898831426_clickPreventStop,
            act_951936257455896_emit_7156,
            evh_951936257455896_close_7155,
            act_951936257455896_showModal_7154,
            evh_951936257455896_click_7153,
            evh_951936257455896_click,
            act_7010716094810887_emit_7160,
            evh_7010716094810887_success_7159,
            act_7010716094810887_request_7158,
            evh_7010716094810887_click_7157,
            evh_7010716094810887_click,
            act_4971252216919813_emit_7164,
            evh_4971252216919813_close_7163,
            act_4971252216919813_showModal_7162,
            evh_4971252216919813_click_7161,
            evh_4971252216919813_click,
            act_3581444176199717_emit_7168,
            evh_3581444176199717_success_7167,
            act_3581444176199717_request_7166,
            evh_3581444176199717_click_7165,
            evh_3581444176199717_click,
            act_6391442819935878_emit_7172,
            evh_6391442819935878_success_7171,
            act_6391442819935878_request_7170,
            evh_6391442819935878_click_7169,
            evh_6391442819935878_click,
            act_2988515090283815_emit_7176,
            evh_2988515090283815_success_7175,
            act_2988515090283815_request_7174,
            evh_2988515090283815_click_7173,
            evh_2988515090283815_click,
            act_3478991899028773_emit_7180,
            evh_3478991899028773_success_7179,
            act_3478991899028773_request_7178,
            evh_3478991899028773_click_7177,
            evh_3478991899028773_click,
            act_8376575288437415_emit_7182,
            evh_8376575288437415_success_7181,
            evh_8376575288437415_success,
            act_3958027742391354_emit_7184,
            evh_3958027742391354_success_7183,
            evh_3958027742391354_success,
            act_8122162285230843_showModal_7186,
            evh_8122162285230843_clickPreventStop_7185,
            evh_8122162285230843_clickPreventStop,
            reload: act_689536327456849_emit_7150,
            registerInvoice: act_951936257455896_showModal_7154,
            createInvoicecopy: act_7010716094810887_request_7158,
            createPassThroughInvoice: act_4971252216919813_showModal_7162,
            createAdvanceInvoice: act_3581444176199717_request_7166,
            createFinalInvoice: act_6391442819935878_request_7170,
            createStornoInvoice: act_2988515090283815_request_7174,
            createCorrectorIvoice: act_3478991899028773_request_7178,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceHeader.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], UcInvoiceHeader.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcInvoiceHeader.prototype, "invoiceNumber", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoiceNumber'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onInvoice_number", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceHeader.prototype, "formContext", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formContext'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onForm_context", null);
UcInvoiceHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceHeader);
exports.default = UcInvoiceHeader;
vue_property_decorator_1.Vue.component("UcInvoiceHeader", UcInvoiceHeader);
